import { NumberFormatter as NF } from "../../../../utils/NumberFormatter";

export interface InchSuggestion {
  value: number;
  stringValue: string;
  label: string;
}

const RAW_SUGGESTIONS = [
  { value: 0.0625, fractionLabel: "1/16" },
  { value: 0.125, fractionLabel: "1/8" },
  { value: 0.1875, fractionLabel: "3/16" },
  { value: 0.25, fractionLabel: "1/4" },
  { value: 0.3125, fractionLabel: "5/16" },
  { value: 0.375, fractionLabel: "3/8" },
  { value: 0.4375, fractionLabel: "7/16" },
  { value: 0.5, fractionLabel: "1/2" },
  { value: 0.5625, fractionLabel: "9/16" },
  { value: 0.625, fractionLabel: "5/8" },
  { value: 0.6875, fractionLabel: "11/16" },
  { value: 0.75, fractionLabel: "3/4" },
  { value: 0.8125, fractionLabel: "13/16" },
  { value: 0.875, fractionLabel: "7/8" },
  { value: 0.9375, fractionLabel: "15/16" },
  { value: 1, fractionLabel: "" },
  { value: 1.0625, fractionLabel: "1 1/16" },
  { value: 1.125, fractionLabel: "1 1/8" },
  { value: 1.1875, fractionLabel: "1 3/16" },
  { value: 1.25, fractionLabel: "1 1/4" },
  { value: 1.3125, fractionLabel: "1 5/16" },
  { value: 1.375, fractionLabel: "1 3/8" },
  { value: 1.4375, fractionLabel: "1 7/16" },
  { value: 1.5, fractionLabel: "1 1/2" },
  { value: 1.5625, fractionLabel: "1 9/16" },
  { value: 1.625, fractionLabel: "1 5/8" },
  { value: 1.6875, fractionLabel: "1 11/16" },
  { value: 1.75, fractionLabel: "1 3/4" },
  { value: 1.8125, fractionLabel: "1 13/16" },
  { value: 1.875, fractionLabel: "1 7/8" },
  { value: 1.9375, fractionLabel: "1 15/16" },
  { value: 2, fractionLabel: "" },
  { value: 2.0625, fractionLabel: "2 1/16" },
  { value: 2.125, fractionLabel: "2 1/8" },
  { value: 2.1875, fractionLabel: "2 3/16" },
  { value: 2.25, fractionLabel: "2 1/4" },
  { value: 2.3125, fractionLabel: "2 5/16" },
  { value: 2.375, fractionLabel: "2 3/8" },
  { value: 2.4375, fractionLabel: "2 7/16" },
  { value: 2.5, fractionLabel: "2 1/2" },
  { value: 2.5625, fractionLabel: "2 9/16" },
  { value: 2.625, fractionLabel: "2 5/8" },
  { value: 2.6875, fractionLabel: "2 11/16" },
  { value: 2.75, fractionLabel: "2 3/4" },
  { value: 2.8125, fractionLabel: "2 13/16" },
  { value: 2.875, fractionLabel: "2 7/8" },
  { value: 2.9375, fractionLabel: "2 15/16" },
  { value: 3, fractionLabel: "" },
  { value: 3.0625, fractionLabel: "3 1/16" },
  { value: 3.125, fractionLabel: "3 1/8" },
  { value: 3.1875, fractionLabel: "3 3/16" },
  { value: 3.25, fractionLabel: "3 1/4" },
  { value: 3.3125, fractionLabel: "3 5/16" },
  { value: 3.375, fractionLabel: "3 3/8" },
  { value: 3.4375, fractionLabel: "3 7/16" },
  { value: 3.5, fractionLabel: "3 1/2" },
  { value: 3.5625, fractionLabel: "3 9/16" },
  { value: 3.625, fractionLabel: "3 5/8" },
  { value: 3.6875, fractionLabel: "3 11/16" },
  { value: 3.75, fractionLabel: "3 3/4" },
  { value: 3.8125, fractionLabel: "3 13/16" },
  { value: 3.875, fractionLabel: "3 7/8" },
  { value: 3.9375, fractionLabel: "3 15/16" },
  { value: 4, fractionLabel: "" },
  { value: 4.0625, fractionLabel: "4 1/16" },
  { value: 4.125, fractionLabel: "4 1/8" },
  { value: 4.1875, fractionLabel: "4 3/16" },
  { value: 4.25, fractionLabel: "4 1/4" },
  { value: 4.3125, fractionLabel: "4 5/16" },
  { value: 4.375, fractionLabel: "4 3/8" },
  { value: 4.4375, fractionLabel: "4 7/16" },
  { value: 4.5, fractionLabel: "4 1/2" },
  { value: 4.5625, fractionLabel: "4 9/16" },
  { value: 4.625, fractionLabel: "4 5/8" },
  { value: 4.6875, fractionLabel: "4 11/16" },
  { value: 4.75, fractionLabel: "4 3/4" },
  { value: 4.8125, fractionLabel: "4 13/16" },
  { value: 4.875, fractionLabel: "4 7/8" },
  { value: 4.9375, fractionLabel: "4 15/16" },
  { value: 5, fractionLabel: "" },
  { value: 5.0625, fractionLabel: "5 1/16" },
  { value: 5.125, fractionLabel: "5 1/8" },
  { value: 5.1875, fractionLabel: "5 3/16" },
  { value: 5.25, fractionLabel: "5 1/4" },
  { value: 5.3125, fractionLabel: "5 5/16" },
  { value: 5.375, fractionLabel: "5 3/8" },
  { value: 5.4375, fractionLabel: "5 7/16" },
  { value: 5.5, fractionLabel: "5 1/2" },
  { value: 5.5625, fractionLabel: "5 9/16" },
  { value: 5.625, fractionLabel: "5 5/8" },
  { value: 5.6875, fractionLabel: "5 11/16" },
  { value: 5.75, fractionLabel: "5 3/4" },
  { value: 5.8125, fractionLabel: "5 13/16" },
  { value: 5.875, fractionLabel: "5 7/8" },
  { value: 5.9375, fractionLabel: "5 15/16" },
  { value: 6, fractionLabel: "" },
  { value: 6.0625, fractionLabel: "6 1/16" },
  { value: 6.125, fractionLabel: "6 1/8" },
  { value: 6.1875, fractionLabel: "6 3/16" },
  { value: 6.25, fractionLabel: "6 1/4" },
  { value: 6.3125, fractionLabel: "6 5/16" },
  { value: 6.375, fractionLabel: "6 3/8" },
  { value: 6.4375, fractionLabel: "6 7/16" },
  { value: 6.5, fractionLabel: "6 1/2" },
  { value: 6.5625, fractionLabel: "6 9/16" },
  { value: 6.625, fractionLabel: "6 5/8" },
  { value: 6.6875, fractionLabel: "6 11/16" },
  { value: 6.75, fractionLabel: "6 3/4" },
  { value: 6.8125, fractionLabel: "6 13/16" },
  { value: 6.875, fractionLabel: "6 7/8" },
  { value: 6.9375, fractionLabel: "6 15/16" },
  { value: 7, fractionLabel: "" },
  { value: 7.0625, fractionLabel: "7 1/16" },
  { value: 7.125, fractionLabel: "7 1/8" },
  { value: 7.1875, fractionLabel: "7 3/16" },
  { value: 7.25, fractionLabel: "7 1/4" },
  { value: 7.3125, fractionLabel: "7 5/16" },
  { value: 7.375, fractionLabel: "7 3/8" },
  { value: 7.4375, fractionLabel: "7 7/16" },
  { value: 7.5, fractionLabel: "7 1/2" },
  { value: 7.5625, fractionLabel: "7 9/16" },
  { value: 7.625, fractionLabel: "7 5/8" },
  { value: 7.6875, fractionLabel: "7 11/16" },
  { value: 7.75, fractionLabel: "7 3/4" },
  { value: 7.8125, fractionLabel: "7 13/16" },
  { value: 7.875, fractionLabel: "7 7/8" },
  { value: 7.9375, fractionLabel: "7 15/16" },
  { value: 8, fractionLabel: "" },
  { value: 8.0625, fractionLabel: "8 1/16" },
  { value: 8.125, fractionLabel: "8 1/8" },
  { value: 8.1875, fractionLabel: "8 3/16" },
  { value: 8.25, fractionLabel: "8 1/4" },
  { value: 8.3125, fractionLabel: "8 5/16" },
  { value: 8.375, fractionLabel: "8 3/8" },
  { value: 8.4375, fractionLabel: "8 7/16" },
  { value: 8.5, fractionLabel: "8 1/2" },
  { value: 8.5625, fractionLabel: "8 9/16" },
  { value: 8.625, fractionLabel: "8 5/8" },
  { value: 8.6875, fractionLabel: "8 11/16" },
  { value: 8.75, fractionLabel: "8 3/4" },
  { value: 8.8125, fractionLabel: "8 13/16" },
  { value: 8.875, fractionLabel: "8 7/8" },
  { value: 8.9375, fractionLabel: "8 15/16" },
  { value: 9, fractionLabel: "" },
  { value: 9.0625, fractionLabel: "9 1/16" },
  { value: 9.125, fractionLabel: "9 1/8" },
  { value: 9.1875, fractionLabel: "9 3/16" },
  { value: 9.25, fractionLabel: "9 1/4" },
  { value: 9.3125, fractionLabel: "9 5/16" },
  { value: 9.375, fractionLabel: "9 3/8" },
  { value: 9.4375, fractionLabel: "9 7/16" },
  { value: 9.5, fractionLabel: "9 1/2" },
  { value: 9.5625, fractionLabel: "9 9/16" },
  { value: 9.625, fractionLabel: "9 5/8" },
  { value: 9.6875, fractionLabel: "9 11/16" },
  { value: 9.75, fractionLabel: "9 3/4" },
  { value: 9.8125, fractionLabel: "9 13/16" },
  { value: 9.875, fractionLabel: "9 7/8" },
  { value: 9.9375, fractionLabel: "9 15/16" },
  { value: 10, fractionLabel: "" },
  { value: 10.0625, fractionLabel: "10 1/16" },
  { value: 10.125, fractionLabel: "10 1/8" },
  { value: 10.1875, fractionLabel: "10 3/16" },
  { value: 10.25, fractionLabel: "10 1/4" },
  { value: 10.3125, fractionLabel: "10 5/16" },
  { value: 10.375, fractionLabel: "10 3/8" },
  { value: 10.4375, fractionLabel: "10 7/16" },
  { value: 10.5, fractionLabel: "10 1/2" },
  { value: 10.5625, fractionLabel: "10 9/16" },
  { value: 10.625, fractionLabel: "10 5/8" },
  { value: 10.6875, fractionLabel: "10 11/16" },
  { value: 10.75, fractionLabel: "10 3/4" },
  { value: 10.8125, fractionLabel: "10 13/16" },
  { value: 10.875, fractionLabel: "10 7/8" },
  { value: 10.9375, fractionLabel: "10 15/16" },
  { value: 11, fractionLabel: "" },
  { value: 11.0625, fractionLabel: "11 1/16" },
  { value: 11.125, fractionLabel: "11 1/8" },
  { value: 11.1875, fractionLabel: "11 3/16" },
  { value: 11.25, fractionLabel: "11 1/4" },
  { value: 11.3125, fractionLabel: "11 5/16" },
  { value: 11.375, fractionLabel: "11 3/8" },
  { value: 11.4375, fractionLabel: "11 7/16" },
  { value: 11.5, fractionLabel: "11 1/2" },
  { value: 11.5625, fractionLabel: "11 9/16" },
  { value: 11.625, fractionLabel: "11 5/8" },
  { value: 11.6875, fractionLabel: "11 11/16" },
  { value: 11.75, fractionLabel: "11 3/4" },
  { value: 11.8125, fractionLabel: "11 13/16" },
  { value: 11.875, fractionLabel: "11 7/8" },
  { value: 11.9375, fractionLabel: "11 15/16" },
  { value: 12, fractionLabel: "" },
  { value: 12.0625, fractionLabel: "12 1/16" },
  { value: 12.125, fractionLabel: "12 1/8" },
  { value: 12.1875, fractionLabel: "12 3/16" },
  { value: 12.25, fractionLabel: "12 1/4" },
  { value: 12.3125, fractionLabel: "12 5/16" },
  { value: 12.375, fractionLabel: "12 3/8" },
  { value: 12.4375, fractionLabel: "12 7/16" },
  { value: 12.5, fractionLabel: "12 1/2" },
  { value: 12.5625, fractionLabel: "12 9/16" },
  { value: 12.625, fractionLabel: "12 5/8" },
  { value: 12.6875, fractionLabel: "12 11/16" },
  { value: 12.75, fractionLabel: "12 3/4" },
  { value: 12.8125, fractionLabel: "12 13/16" },
  { value: 12.875, fractionLabel: "12 7/8" },
  { value: 12.9375, fractionLabel: "12 15/16" },
  { value: 13, fractionLabel: "" },
  { value: 13.0625, fractionLabel: "13 1/16" },
  { value: 13.125, fractionLabel: "13 1/8" },
  { value: 13.1875, fractionLabel: "13 3/16" },
  { value: 13.25, fractionLabel: "13 1/4" },
  { value: 13.3125, fractionLabel: "13 5/16" },
  { value: 13.375, fractionLabel: "13 3/8" },
  { value: 13.4375, fractionLabel: "13 7/16" },
  { value: 13.5, fractionLabel: "13 1/2" },
  { value: 13.5625, fractionLabel: "13 9/16" },
  { value: 13.625, fractionLabel: "13 5/8" },
  { value: 13.6875, fractionLabel: "13 11/16" },
  { value: 13.75, fractionLabel: "13 3/4" },
  { value: 13.8125, fractionLabel: "13 13/16" },
  { value: 13.875, fractionLabel: "13 7/8" },
  { value: 13.9375, fractionLabel: "13 15/16" },
  { value: 14, fractionLabel: "" },
  { value: 14.0625, fractionLabel: "14 1/16" },
  { value: 14.125, fractionLabel: "14 1/8" },
  { value: 14.1875, fractionLabel: "14 3/16" },
  { value: 14.25, fractionLabel: "14 1/4" },
  { value: 14.3125, fractionLabel: "14 5/16" },
  { value: 14.375, fractionLabel: "14 3/8" },
  { value: 14.4375, fractionLabel: "14 7/16" },
  { value: 14.5, fractionLabel: "14 1/2" },
  { value: 14.5625, fractionLabel: "14 9/16" },
  { value: 14.625, fractionLabel: "14 5/8" },
  { value: 14.6875, fractionLabel: "14 11/16" },
  { value: 14.75, fractionLabel: "14 3/4" },
  { value: 14.8125, fractionLabel: "14 13/16" },
  { value: 14.875, fractionLabel: "14 7/8" },
  { value: 14.9375, fractionLabel: "14 15/16" },
  { value: 15, fractionLabel: "" },
  { value: 15.0625, fractionLabel: "15 1/16" },
  { value: 15.125, fractionLabel: "15 1/8" },
  { value: 15.1875, fractionLabel: "15 3/16" },
  { value: 15.25, fractionLabel: "15 1/4" },
  { value: 15.3125, fractionLabel: "15 5/16" },
  { value: 15.375, fractionLabel: "15 3/8" },
  { value: 15.4375, fractionLabel: "15 7/16" },
  { value: 15.5, fractionLabel: "15 1/2" },
  { value: 15.5625, fractionLabel: "15 9/16" },
  { value: 15.625, fractionLabel: "15 5/8" },
  { value: 15.6875, fractionLabel: "15 11/16" },
  { value: 15.75, fractionLabel: "15 3/4" },
  { value: 15.8125, fractionLabel: "15 13/16" },
  { value: 15.875, fractionLabel: "15 7/8" },
  { value: 15.9375, fractionLabel: "15 15/16" },
  { value: 16, fractionLabel: "" },
  { value: 16.0625, fractionLabel: "16 1/16" },
  { value: 16.125, fractionLabel: "16 1/8" },
  { value: 16.1875, fractionLabel: "16 3/16" },
  { value: 16.25, fractionLabel: "16 1/4" },
  { value: 16.3125, fractionLabel: "16 5/16" },
  { value: 16.375, fractionLabel: "16 3/8" },
  { value: 16.4375, fractionLabel: "16 7/16" },
  { value: 16.5, fractionLabel: "16 1/2" },
  { value: 16.5625, fractionLabel: "16 9/16" },
  { value: 16.625, fractionLabel: "16 5/8" },
  { value: 16.6875, fractionLabel: "16 11/16" },
  { value: 16.75, fractionLabel: "16 3/4" },
  { value: 16.8125, fractionLabel: "16 13/16" },
  { value: 16.875, fractionLabel: "16 7/8" },
  { value: 16.9375, fractionLabel: "16 15/16" },
  { value: 17, fractionLabel: "" },
  { value: 17.0625, fractionLabel: "17 1/16" },
  { value: 17.125, fractionLabel: "17 1/8" },
  { value: 17.1875, fractionLabel: "17 3/16" },
  { value: 17.25, fractionLabel: "17 1/4" },
  { value: 17.3125, fractionLabel: "17 5/16" },
  { value: 17.375, fractionLabel: "17 3/8" },
  { value: 17.4375, fractionLabel: "17 7/16" },
  { value: 17.5, fractionLabel: "17 1/2" },
  { value: 17.5625, fractionLabel: "17 9/16" },
  { value: 17.625, fractionLabel: "17 5/8" },
  { value: 17.6875, fractionLabel: "17 11/16" },
  { value: 17.75, fractionLabel: "17 3/4" },
  { value: 17.8125, fractionLabel: "17 13/16" },
  { value: 17.875, fractionLabel: "17 7/8" },
  { value: 17.9375, fractionLabel: "17 15/16" },
  { value: 18, fractionLabel: "" },
  { value: 18.0625, fractionLabel: "18 1/16" },
  { value: 18.125, fractionLabel: "18 1/8" },
  { value: 18.1875, fractionLabel: "18 3/16" },
  { value: 18.25, fractionLabel: "18 1/4" },
  { value: 18.3125, fractionLabel: "18 5/16" },
  { value: 18.375, fractionLabel: "18 3/8" },
  { value: 18.4375, fractionLabel: "18 7/16" },
  { value: 18.5, fractionLabel: "18 1/2" },
  { value: 18.5625, fractionLabel: "18 9/16" },
  { value: 18.625, fractionLabel: "18 5/8" },
  { value: 18.6875, fractionLabel: "18 11/16" },
  { value: 18.75, fractionLabel: "18 3/4" },
  { value: 18.8125, fractionLabel: "18 13/16" },
  { value: 18.875, fractionLabel: "18 7/8" },
  { value: 18.9375, fractionLabel: "18 15/16" },
  { value: 19, fractionLabel: "" },
  { value: 19.0625, fractionLabel: "19 1/16" },
  { value: 19.125, fractionLabel: "19 1/8" },
  { value: 19.1875, fractionLabel: "19 3/16" },
  { value: 19.25, fractionLabel: "19 1/4" },
  { value: 19.3125, fractionLabel: "19 5/16" },
  { value: 19.375, fractionLabel: "19 3/8" },
  { value: 19.4375, fractionLabel: "19 7/16" },
  { value: 19.5, fractionLabel: "19 1/2" },
  { value: 19.5625, fractionLabel: "19 9/16" },
  { value: 19.625, fractionLabel: "19 5/8" },
  { value: 19.6875, fractionLabel: "19 11/16" },
  { value: 19.75, fractionLabel: "19 3/4" },
  { value: 19.8125, fractionLabel: "19 13/16" },
  { value: 19.875, fractionLabel: "19 7/8" },
  { value: 19.9375, fractionLabel: "19 15/16" },
  { value: 20, fractionLabel: "" },
  { value: 20.0625, fractionLabel: "20 1/16" },
  { value: 20.125, fractionLabel: "20 1/8" },
  { value: 20.1875, fractionLabel: "20 3/16" },
  { value: 20.25, fractionLabel: "20 1/4" },
  { value: 20.3125, fractionLabel: "20 5/16" },
  { value: 20.375, fractionLabel: "20 3/8" },
  { value: 20.4375, fractionLabel: "20 7/16" },
  { value: 20.5, fractionLabel: "20 1/2" },
  { value: 20.5625, fractionLabel: "20 9/16" },
  { value: 20.625, fractionLabel: "20 5/8" },
  { value: 20.6875, fractionLabel: "20 11/16" },
  { value: 20.75, fractionLabel: "20 3/4" },
  { value: 20.8125, fractionLabel: "20 13/16" },
  { value: 20.875, fractionLabel: "20 7/8" },
  { value: 20.9375, fractionLabel: "20 15/16" },
  { value: 21, fractionLabel: "" },
  { value: 21.0625, fractionLabel: "21 1/16" },
  { value: 21.125, fractionLabel: "21 1/8" },
  { value: 21.1875, fractionLabel: "21 3/16" },
  { value: 21.25, fractionLabel: "21 1/4" },
  { value: 21.3125, fractionLabel: "21 5/16" },
  { value: 21.375, fractionLabel: "21 3/8" },
  { value: 21.4375, fractionLabel: "21 7/16" },
  { value: 21.5, fractionLabel: "21 1/2" },
  { value: 21.5625, fractionLabel: "21 9/16" },
  { value: 21.625, fractionLabel: "21 5/8" },
  { value: 21.6875, fractionLabel: "21 11/16" },
  { value: 21.75, fractionLabel: "21 3/4" },
  { value: 21.8125, fractionLabel: "21 13/16" },
  { value: 21.875, fractionLabel: "21 7/8" },
  { value: 21.9375, fractionLabel: "21 15/16" },
  { value: 22, fractionLabel: "" },
  { value: 22.0625, fractionLabel: "22 1/16" },
  { value: 22.125, fractionLabel: "22 1/8" },
  { value: 22.1875, fractionLabel: "22 3/16" },
  { value: 22.25, fractionLabel: "22 1/4" },
  { value: 22.3125, fractionLabel: "22 5/16" },
  { value: 22.375, fractionLabel: "22 3/8" },
  { value: 22.4375, fractionLabel: "22 7/16" },
  { value: 22.5, fractionLabel: "22 1/2" },
  { value: 22.5625, fractionLabel: "22 9/16" },
  { value: 22.625, fractionLabel: "22 5/8" },
  { value: 22.6875, fractionLabel: "22 11/16" },
  { value: 22.75, fractionLabel: "22 3/4" },
  { value: 22.8125, fractionLabel: "22 13/16" },
  { value: 22.875, fractionLabel: "22 7/8" },
  { value: 22.9375, fractionLabel: "22 15/16" },
];

let suggestions: InchSuggestion[] | null = null;

export const getInchSuggestions = () => {
  if (!suggestions) {
    suggestions = RAW_SUGGESTIONS.map(({ value, fractionLabel }) => {
      const number = NF.getDefaultFormatter().format(value);
      const label = fractionLabel ? `${number} (${fractionLabel})` : number;

      return {
        value,
        stringValue: number,
        label,
      };
    });
  }

  return suggestions;
};
